import React from 'react'
import { useNavigate } from 'react-router'
import { AccountHeader } from '@mobi/component-library/Account'
import { Button, FeatureIcon, Icon } from '@mobi/component-library/Common/V2'
import { colors } from '@mobi/component-library/Theme/Common'
import { Content, Footer, SignUpPageStyled } from './SignUpPage.styled'
import { isReactNativeApp, isReactNativeIos, sendToNative } from '@mobi/web-native-comms/web'
import { useBiometricsStatus } from '../../Verification/Biometrics/Hooks/useBiometricsStatus'
import { Toggle } from '@mobi/component-library/Selection&Input/Toggle'
import {
  Selector,
  SelectorHeading,
  MessageContainer,
  ToggleGroupItem,
  ChildrenContainer,
} from './SecuritySettings.styled'
import { routes } from '../Utils'

type Props = { betAccountNumber?: number; password: string }

export const SecuritySettings = ({ betAccountNumber, password }: Props) => {
  const [isBiometricsToggleOn, setIsBiometricsToggleOn] = React.useState(true)

  const navigate = useNavigate()
  const { biometricsStatus } = useBiometricsStatus()

  const biometricsType = biometricsStatus?.biometricsType
  const isFaceId = biometricsType == 'FACIAL_RECOGNITION' && isReactNativeIos
  const promptText = isFaceId ? 'Enable Face ID' : 'Enable PIN / Biometrics'

  React.useEffect(() => {
    // clear any biometrics password that might be saved from a previously logged in user
    if (betAccountNumber) {
      sendToNative('REMOVE_BIOMETRICS_PASSWORD')
    }
  }, [betAccountNumber])

  if (!betAccountNumber || !password) return

  return (
    <SignUpPageStyled>
      <AccountHeader
        alignItems='start'
        title='Protect your TABtouch account'
        description='Adding extra security will ensure you are the only one who can access your TABtouch account.'
        style={{ marginBottom: '0rem' }}
      />
      <Content>
        <Selector>
          <SelectorHeading>
            <Icon name='SolidLock01' color={colors.studio[500]} size='2.4rem' />
            <MessageContainer>
              <div>Security</div>
              <div>Make your account more secure</div>
            </MessageContainer>
          </SelectorHeading>
          {isReactNativeApp && (
            <ToggleGroupItem id='biometrics'>
              <FeatureIcon type='custom' size='md'>
                <Icon name='LineFaceId' color={colors.lavender['600']} size='1.6rem' />
              </FeatureIcon>
              <ChildrenContainer>{promptText}</ChildrenContainer>
              <Toggle
                id='biometrics-toggle'
                isOn={isBiometricsToggleOn}
                onToggle={function (): void {
                  setIsBiometricsToggleOn(!isBiometricsToggleOn)
                }}
              />
            </ToggleGroupItem>
          )}
        </Selector>
      </Content>
      <Footer>
        <Button
          color='primary'
          isFullWidth
          size='md'
          onClick={() => {
            if (isReactNativeApp && isBiometricsToggleOn && password != null) {
              sendToNative('SET_BIOMETRICS_PASSWORD', {
                accountNumber: betAccountNumber,
                password: password,
              })
            }
            navigate(routes.depositLimit)
          }}
        >
          Continue
        </Button>
        <Button
          color='tertiary_color'
          isFullWidth
          size='md'
          onClick={() => navigate(routes.depositLimit)}
        >
          Skip for now
        </Button>
      </Footer>
    </SignUpPageStyled>
  )
}
